module.exports = __webpack_public_path__ + "static/media/01_design_agd-comptoir-pao.cb80822a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design_agd-comptoir-pao.jpg
// module id = 233
// module chunks = 0